import { useQuery } from '@tanstack/react-query';
import { cashPoolKeys } from '@/services/query-keys/cash-pool-keys';
import {
  cashPoolService,
  CashPoolListParams,
} from '@/services/cash-pool/cash-pool-service';

/**
 * LR-586: `enabled` lets the Trade Entry dropdown hold the query until the
 * counterparty and currency it filters on are known - without it every keystroke
 * before a counterparty is picked would fetch the whole pool registry.
 * `staleTime` lets that same dropdown opt out of the 5-minute cache: the "no
 * pool fits" link opens Collateral Manager in a second tab, so the pool the
 * trader creates there never reaches this cache, and booking must not run
 * against a list that no longer reflects the registry.
 */
export const useCashPools = (
  params?: CashPoolListParams,
  options?: { enabled?: boolean; staleTime?: number }
) => {
  return useQuery({
    queryKey: cashPoolKeys.list(JSON.stringify(params || {})),
    queryFn: () => cashPoolService.getCashPools(params),
    staleTime: options?.staleTime ?? 5 * 60 * 1000,
    enabled: options?.enabled ?? true,
  });
};
